import type React from "react";
// Safe markdown renderer shared by sheets and assistant replies
  const parseInlineMarkdown = (text: string): React.ReactNode => {
    if (!text) return "";
    const parts: React.ReactNode[] = [];
    const regex = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
    let lastIdx = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIdx) {
        parts.push(text.substring(lastIdx, match.index));
      }
      const token = match[0];
      if (token.startsWith("**") && token.endsWith("**")) {
        parts.push(<strong key={match.index}>{token.slice(2, -2)}</strong>);
      } else if (token.startsWith("*") && token.endsWith("*")) {
        parts.push(<em key={match.index}>{token.slice(1, -1)}</em>);
      } else if (token.startsWith("`") && token.endsWith("`")) {
        parts.push(<code key={match.index} className="inline-code">{token.slice(1, -1)}</code>);
      }
      lastIdx = regex.lastIndex;
    }

    if (lastIdx < text.length) {
      parts.push(text.substring(lastIdx));
    }

    return parts.length > 0 ? parts : text;
  };

export const renderMarkdownProse = (content: string) => {
    if (!content) return null;
    const lines = content.split("\n");
    const blocks: React.ReactNode[] = [];
    let currentList: string[] = [];

    const flushList = (key: string) => {
      if (currentList.length > 0) {
        blocks.push(
          <ul key={key} className="orbit-msg-list" style={{ margin: "4px 0 8px 18px", padding: 0 }}>
            {currentList.map((item, idx) => (
              <li key={idx} style={{ marginBottom: "2px" }}>{parseInlineMarkdown(item)}</li>
            ))}
          </ul>
        );
        currentList = [];
      }
    };

    const consumed = new Set<number>();
    const cells = (line: string) => line.trim().replace(/^\||\|$/g, "").split("|").map(cell => cell.trim());
    lines.forEach((line, idx) => {
      if (consumed.has(idx)) return;
      const trimmed = line.trim();
      if (trimmed.includes("|") && /^\s*\|?\s*:?-{3,}/.test(lines[idx + 1] || "")) {
        flushList(`list-${idx}`);
        const headers = cells(line), rows: string[][] = [];
        consumed.add(idx + 1);
        for (let row = idx + 2; row < lines.length && lines[row]!.trim().includes("|"); row++) { rows.push(cells(lines[row]!)); consumed.add(row); }
        blocks.push(<div className="movis-table" key={`table-${idx}`}><table><thead><tr>{headers.map((header, i) => <th key={i}>{parseInlineMarkdown(header)}</th>)}</tr></thead><tbody>{rows.map((row, i) => <tr key={i}>{headers.map((_, j) => <td key={j}>{parseInlineMarkdown(row[j] || "")}</td>)}</tr>)}</tbody></table></div>);
        return;
      }
      if (trimmed.startsWith("• ") || trimmed.startsWith("- ") || trimmed.startsWith("* ")) {
        currentList.push(trimmed.slice(2));
      } else if (trimmed.startsWith("### ")) {
        flushList(`list-${idx}`);
        blocks.push(<h4 key={`h-${idx}`} style={{ margin: "8px 0 4px", fontSize: "13px" }}>{parseInlineMarkdown(trimmed.slice(4))}</h4>);
      } else if (trimmed.startsWith("## ") || trimmed.startsWith("# ")) {
        flushList(`list-${idx}`);
        blocks.push(<h3 key={`h-${idx}`} style={{ margin: "10px 0 4px", fontSize: "14px" }}>{parseInlineMarkdown(trimmed.replace(/^#+\s*/, ""))}</h3>);
      } else if (trimmed === "") {
        flushList(`list-${idx}`);
      } else {
        flushList(`list-${idx}`);
        blocks.push(<p key={`p-${idx}`} style={{ margin: "0 0 6px 0", lineHeight: "1.5" }}>{parseInlineMarkdown(line)}</p>);
      }
    });
    flushList("list-end");

    return blocks;
  };

  